export enum EnumAssignTo {
  POS = 'POS',
  COURIER = 'Kurir',
}
